/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AttendeeRelation,
    AttendeeRelationFromJSON,
    AttendeeRelationFromJSONTyped,
    AttendeeRelationToJSON,
} from './AttendeeRelation';
import {
    FeedbackRating,
    FeedbackRatingFromJSON,
    FeedbackRatingFromJSONTyped,
    FeedbackRatingToJSON,
} from './FeedbackRating';
import {
    FileObject,
    FileObjectFromJSON,
    FileObjectFromJSONTyped,
    FileObjectToJSON,
} from './FileObject';
import {
    Gender,
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
} from './Gender';
import {
    ProgramAttendeeObjectType,
    ProgramAttendeeObjectTypeFromJSON,
    ProgramAttendeeObjectTypeFromJSONTyped,
    ProgramAttendeeObjectTypeToJSON,
} from './ProgramAttendeeObjectType';
import {
    User,
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface ProgramAttendee
 */
export interface ProgramAttendee {
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    id: string;
    /**
     * 
     * @type {ProgramAttendeeObjectType}
     * @memberof ProgramAttendee
     */
    object: ProgramAttendeeObjectType;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    program_id: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    attendee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    picture_url?: string;
    /**
     * 
     * @type {FileObject}
     * @memberof ProgramAttendee
     */
    picture?: FileObject;
    /**
     * 
     * @type {Array<AttendeeRelation>}
     * @memberof ProgramAttendee
     */
    relations: Array<AttendeeRelation>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramAttendee
     */
    has_active_memberships: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProgramAttendee
     */
    num_registrations: number;
    /**
     * 
     * @type {Date}
     * @memberof ProgramAttendee
     */
    first_attended?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProgramAttendee
     */
    last_attended?: Date;
    /**
     * 
     * @type {FeedbackRating}
     * @memberof ProgramAttendee
     */
    average_feedback?: FeedbackRating;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    date_of_birth?: string;
    /**
     * 
     * @type {Gender}
     * @memberof ProgramAttendee
     */
    gender?: Gender;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramAttendee
     */
    medical_history: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramAttendee
     */
    dietary_restrictions: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    health_card_last4?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    primary_contact_id: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    parent_name: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    emergency_contact_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    emergency_contact_email?: string;
    /**
     * 
     * @type {any}
     * @memberof ProgramAttendee
     */
    properties: any;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramAttendee
     */
    is_archived: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendee
     */
    timezone: string;
    /**
     * 
     * @type {Date}
     * @memberof ProgramAttendee
     */
    created: Date;
    /**
     * 
     * @type {User}
     * @memberof ProgramAttendee
     */
    created_by: User;
    /**
     * 
     * @type {Date}
     * @memberof ProgramAttendee
     */
    updated?: Date;
    /**
     * 
     * @type {User}
     * @memberof ProgramAttendee
     */
    updated_by?: User;
}

export function ProgramAttendeeFromJSON(json: any): ProgramAttendee {
    return ProgramAttendeeFromJSONTyped(json, false);
}

export function ProgramAttendeeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramAttendee {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': ProgramAttendeeObjectTypeFromJSON(json['object']),
        'program_id': json['program_id'],
        'attendee_id': !exists(json, 'attendee_id') ? undefined : json['attendee_id'],
        'first_name': json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'picture_url': !exists(json, 'picture_url') ? undefined : json['picture_url'],
        'picture': !exists(json, 'picture') ? undefined : FileObjectFromJSON(json['picture']),
        'relations': ((json['relations'] as Array<any>).map(AttendeeRelationFromJSON)),
        'has_active_memberships': json['has_active_memberships'],
        'num_registrations': json['num_registrations'],
        'first_attended': !exists(json, 'first_attended') ? undefined : (new Date(json['first_attended'])),
        'last_attended': !exists(json, 'last_attended') ? undefined : (new Date(json['last_attended'])),
        'average_feedback': !exists(json, 'average_feedback') ? undefined : FeedbackRatingFromJSON(json['average_feedback']),
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'date_of_birth': !exists(json, 'date_of_birth') ? undefined : json['date_of_birth'],
        'gender': !exists(json, 'gender') ? undefined : GenderFromJSON(json['gender']),
        'medical_history': json['medical_history'],
        'dietary_restrictions': json['dietary_restrictions'],
        'health_card_last4': !exists(json, 'health_card_last4') ? undefined : json['health_card_last4'],
        'primary_contact_id': json['primary_contact_id'],
        'parent_name': json['parent_name'],
        'emergency_contact_phone': !exists(json, 'emergency_contact_phone') ? undefined : json['emergency_contact_phone'],
        'emergency_contact_email': !exists(json, 'emergency_contact_email') ? undefined : json['emergency_contact_email'],
        'properties': json['properties'],
        'is_archived': json['is_archived'],
        'timezone': json['timezone'],
        'created': (new Date(json['created'])),
        'created_by': UserFromJSON(json['created_by']),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
        'updated_by': !exists(json, 'updated_by') ? undefined : UserFromJSON(json['updated_by']),
    };
}

export function ProgramAttendeeToJSON(value?: ProgramAttendee | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': ProgramAttendeeObjectTypeToJSON(value.object),
        'program_id': value.program_id,
        'attendee_id': value.attendee_id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'email': value.email,
        'picture_url': value.picture_url,
        'picture': FileObjectToJSON(value.picture),
        'relations': ((value.relations as Array<any>).map(AttendeeRelationToJSON)),
        'has_active_memberships': value.has_active_memberships,
        'num_registrations': value.num_registrations,
        'first_attended': value.first_attended === undefined ? undefined : (value.first_attended.toISOString()),
        'last_attended': value.last_attended === undefined ? undefined : (value.last_attended.toISOString()),
        'average_feedback': FeedbackRatingToJSON(value.average_feedback),
        'phone': value.phone,
        'date_of_birth': value.date_of_birth,
        'gender': GenderToJSON(value.gender),
        'medical_history': value.medical_history,
        'dietary_restrictions': value.dietary_restrictions,
        'health_card_last4': value.health_card_last4,
        'primary_contact_id': value.primary_contact_id,
        'parent_name': value.parent_name,
        'emergency_contact_phone': value.emergency_contact_phone,
        'emergency_contact_email': value.emergency_contact_email,
        'properties': value.properties,
        'is_archived': value.is_archived,
        'timezone': value.timezone,
        'created': (value.created.toISOString()),
        'created_by': UserToJSON(value.created_by),
        'updated': value.updated === undefined ? undefined : (value.updated.toISOString()),
        'updated_by': UserToJSON(value.updated_by),
    };
}

